exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1VQRs{margin-top:22px}._66PU4{cursor:pointer;padding:2px 8px;height:64px;width:calc(33.33333vw - 4px);max-width:160px;color:#606060!important;font-size:15px;font-weight:700;text-align:center}._66PU4:hover{border-color:transparent!important}._66PU4 ._2jUB-{height:3px;background-color:#606060;margin-top:8px}._66PU4.XOZuj{color:#000!important}._66PU4.XOZuj ._2jUB-{background-color:#e02519}._23_mA{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:16px}", ""]);

// exports
exports.locals = {
	"searchButton": "_1VQRs",
	"tab": "_66PU4",
	"tabFloor": "_2jUB-",
	"active": "XOZuj",
	"tabs": "_23_mA"
};